// module factories are used so entry inlining is disabled
// startup
// Load entry module and return exports
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_amplitude_analytics-browser_lib_esm_index_js-node_modules_loadable_compo-29922d"], () => (__webpack_require__("./src/js/app.tsx")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
